import { render, staticRenderFns } from "./FundingDetails.vue?vue&type=template&id=5e6fc764&scoped=true&"
import script from "./FundingDetails.vue?vue&type=script&lang=js&"
export * from "./FundingDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetails.vue?vue&type=style&index=0&id=5e6fc764&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6fc764",
  null
  
)

export default component.exports